import React from 'react';
import TestimonialSwiper from './TestimonialSwiper';

const TestimonialSwiperDemo = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            TestimonialSwiper Demo
          </h1>
          <p className="text-xl text-gray-600">
            Interactive 3D Coverflow Testimonial Carousel
          </p>
        </div>
        
        <TestimonialSwiper />
        
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Features
          </h2>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">3D Coverflow Effect</h3>
              <p className="text-gray-600">
                Beautiful 3D rotation and depth effects for an immersive experience
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">Interactive Navigation</h3>
              <p className="text-gray-600">
                Drag to swipe, click pagination dots, or use arrow buttons
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="font-bold text-lg mb-2">Responsive Design</h3>
              <p className="text-gray-600">
                Optimized for all screen sizes with smooth animations
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSwiperDemo;
